import { useEnhancedPDFGeneration } from './useEnhancedPDFGeneration';
import type { EnhancedUnifiedFormData } from '@/validation/enhancedUnifiedSchemas';

export const useSupremeIntelligencePDFGeneration = () => {
  const { generateEnhancedPDF, isGenerating, generateSmartFilename } = useEnhancedPDFGeneration();

  const generateSupremeIntelligencePDF = async (
    elementRef: React.RefObject<HTMLDivElement>,
    formData?: EnhancedUnifiedFormData
  ) => {
    return await generateEnhancedPDF(elementRef, {
      filename: generateSmartFilename('supreme-intelligence-analysis'),
      reportType: 'Supreme Intelligence Analysis',
      scale: 2,
      quality: 0.95,
      includeMetadata: true,
      userInfo: formData ? {
        name: `${formData.personalDetails.firstName} ${formData.personalDetails.lastName}`,
        email: formData.personalDetails.email,
      } : undefined,
    });
  };

  return {
    generateSupremeIntelligencePDF,
    isGenerating,
  };
};
